import { useLocation, useSearchParams } from "react-router";

import HelpDialog from "./HelpDialog";
import NavigationMenu from "./NavigationMenu/NavigationMenu";

import CookieDialog from './CookieDialog';

import { Outlet } from "react-router";
import { AuthTimeout } from "./Authentication/AuthTimeout";
import { Helmet } from "./Helmet";
import { useSettingsContext } from "./Settings/hooks/useSettingsContext";
import AnalyticsProvider from "./Analytics";
import OneTrust from "./ConsentManager/OneTrust";
import Footer from "./Footer";
import { configureConsent, isOneTrustEnabled } from "@/services/consent";

const SHOW_NAVIGATION_MENU_KEY = "showNavigationMenu";

const RootPage = () => {
  const Settings = useSettingsContext();
  const {pathname} = useLocation();
  const [searchParams] = useSearchParams();
  // Called while rendering, not in an effect: children effects (e.g. AnalyticsProvider) run
  // before this component's, and the consent helpers used outside React (utils/cookies.js,
  // utils/hooks.js) read this global configuration.
  configureConsent(Settings);

  const showNavigationMenu = searchParams.get(SHOW_NAVIGATION_MENU_KEY)?.toLowerCase() !== "false";

  return pathname !== '/omipComponent' ?
    <>
      <AuthTimeout />
      {showNavigationMenu && <NavigationMenu />}

      <section id="app">
        <Helmet />
        <Outlet />
        <Footer />
        { Settings?.helpDialog?.enabled && (
          <HelpDialog />
        )}
        <OneTrust />
        <AnalyticsProvider />
        {!isOneTrustEnabled(Settings) && <CookieDialog />}
      </section>
    </>
  :
    <Outlet />
};

export default RootPage;
